module.exports = __webpack_public_path__ + "static/media/undraw_responsive.6f625599.svg";